import React from 'react';

import { CustomModal } from '@shared/ui';
import { TFilesModalMode } from '@widgets/Files/model/types/modalMode.type';
import { FolderModal } from '@widgets/Files/UI/Modals/FolderModal';

import { Delete } from './Delete';
import { Edit } from './Edit';
import cls from './ModalFiles.module.css';
import { Popup } from './Popup';
import { PrevModal } from './PrevModal';

interface IModalFilesProps {
    mode: TFilesModalMode | 'prev';
    onHideModal: () => void;
}

export const ModalFiles = ({ mode = null, onHideModal }: IModalFilesProps) => {
    if (!mode) return null;

    if (mode === 'prev') {
        return <PrevModal onHideModal={onHideModal} />;
    }

    return (
        <CustomModal
            isOpen={!!mode}
            onHideModal={onHideModal}
            needClose={false}
            contentClasses={cls.customModalContentClass}
        >
            {mode === 'delete' && (
                <Delete isShow={mode === 'delete'} onHideModal={onHideModal} mode={mode} />
            )}
            {mode === 'folderDelete' && (
                <Delete isShow={mode === 'folderDelete'} onHideModal={onHideModal} mode={mode} />
            )}
            {mode === 'edit' && <Edit isShow={mode === 'edit'} onHideModal={onHideModal} />}
            {mode === 'popup' && (
                <Popup isShow={mode === 'popup'} onHideModal={onHideModal} error="format" />
            )}
            {mode === 'folderCreate' && (
                <FolderModal
                    folderModalType="folderCreate"
                    onHideModal={onHideModal}
                    isShow={mode === 'folderCreate'}
                />
            )}
            {mode === 'folderEdit' && (
                <FolderModal
                    folderModalType="folderEdit"
                    onHideModal={onHideModal}
                    isShow={mode === 'folderEdit'}
                />
            )}
        </CustomModal>
    );
};
